"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AtsiController = function AtsiController($scope, DTOptionsBuilder, DTColumnBuilder, User, Constants, FunctionService, CONST, materialButtons, datePicker, $rootScope) {
  _classCallCheck(this, AtsiController);

  this.datatableApi;
  this.user = User.getUser();
  this.name = "ATSI Episode List";
  this.episodeValue = "";
  this.specialtyString = "";
  this.separationString = "";
  this.locale = "en-au";

  this.url = WEBSERVICEURL + "/dataagility/api/service.episodeaudit?removeCoding=1&";
  this.initUrl = this.url + "startDate=" + moment().locale(this.locale).subtract(1, "months").startOf("month").format("L") + "&endDate=" + moment().locale(this.locale).subtract(1, "days").format("L") + "&atsi=";

  materialButtons.render();

  materialButtons.processing();

  $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
    // Datatables has finished init
    // Initialise searching
    if ($scope.vm.datatableApi) return;

    $scope.vm.datatableApi = this.api();

    // Update column headers even when no data returned
    setDtHeaders($scope.vm.datatableApi);

    // setup search filters
    search();

    // tell DataTables we're using Aussie-formatted dates for ordering
    $.fn.dataTable.moment("DD/MM/YYYY HH:mm");

    // set the table to a fixed height, so it never collapsed up and down
    $("#auditTable").closest(".dataTables_scrollBody").height(300);
  };

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.functionSettings = response.functionSettings;
    $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;

    // All Private Clients should be active, All Public should be inactive
    if ($scope.vm.episodeValue === '$') {
      console.log('WIES vars set to private');
      $scope.vm.wiesDefault = "0.00";
      $scope.vm.wiesParseAmount = 2;
    } else {
      console.log('WIES vars set to public');
      $scope.vm.wiesDefault = "0.0000";
      $scope.vm.wiesParseAmount = 4;
    }

    if (!($scope.vm.functionSettings.ShowDRGVersion && $scope.vm.functionSettings.ShowDRGVersion.isActive)) {
      var drgVersionColumn = $scope.vm.dtColumns.filter(function (x) {
        return x.mData === "drgVersion";
      });
      var indexOfDRGVersionColumn = $scope.vm.dtColumns.indexOf(drgVersionColumn[0]);
      $scope.vm.dtColumns.splice(indexOfDRGVersionColumn, 1);
    }

    Constants.campusData().then(function successCallback(response) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
        var campusOptions = [];
        if (typeof $scope.vm.user.campus === "string") {
          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
        } else {
          campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
        }
        $scope.vm.campusOptions = campusOptions;
        $scope.vm.campus.selectedCampus = campusOptions;
      } else {
        $scope.vm.campusOptions = response;
      }
      filterCampus($scope.vm.campusOptions);
    });
  });

  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
    headers: {
      Authorization: "Bearer " + $rootScope.globals.currentUser.token
    }, url: $scope.vm.initUrl, type: "GET", error: function error(xhr, _error, thrown) {
      if (thrown == "Unauthorized") window.location.replace(window.location.origin + "/login");
    }
  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
    // Update column headers if data returned
    setDtHeaders($("#auditTable").DataTable());
  }).withOption("rowCallback", $scope.rowCallback).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[2, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
    extend: "print", text: ""
  }, {
    extend: "csvHtml5", text: "", filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    extend: "excelHtml5", text: "", filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    text: "", action: function action(e, dt, node, config) {
      dt.ajax.reload();
    }
  }]).withColumnFilter({
    //sPlaceHolder: "head:after",
    aoColumns: [{ type: "number" }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "select" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "number" }, { type: "date-range" }]
  });

  this.dtColumns = [DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("urn").withTitle("UR Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("atsi").withTitle("ATSI Status").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("speciality").withTitle("Loading...").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("auditCriteria").withTitle("Audit Criteria").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("status").withTitle("Audit Status").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drgVersion").withTitle("DRG Version").withOption("defaultContent", "").withOption("width", "5%").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("drg").withTitle("Original DRG").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("finalDRG").withTitle("Final DRG").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("wies").withTitle("Original").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return parseFloat(data) ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : $scope.vm.wiesDefault;
  }), DTColumnBuilder.newColumn("finalWIES").withTitle("Final").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? parseFloat(data).toFixed($scope.vm.wiesParseAmount) : '';
  }), DTColumnBuilder.newColumn("totalWIESChange").withTitle("Difference").withOption("defaultContent", $scope.vm.wiesDefault).withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return parseFloat(data).toFixed($scope.vm.wiesParseAmount);
  }), DTColumnBuilder.newColumn("auditFinalisedDateTime").withTitle("Date Audit Finalised").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return data ? moment(data).format('DD/MM/YYYY HH:MM') : '';
  }), DTColumnBuilder.newColumn("atsi").withTitle("ATSI FOR TESTING").withClass("mdl-data-table__cell--non-numeric").notVisible()];

  // Search filters
  this.campus = {
    selectedCampus: []
  };
  this.campusOptions = [];
  this.specialty = {
    selectedSpecialty: []
  };
  this.specialtyOptions = {};

  this.atsi = {
    selectedAtsi: []
  };
  this.atsiOptions = [];

  Constants.lookupsData($scope.vm.user.id, "atsi").then(function successCallback(response) {
    $scope.vm.atsiOptions = response;
  });

  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
    $scope.vm.specialtyOptions = response.specialties;
    filterSpecialty($scope.vm.specialtyOptions);
  });

  this.startDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "months").startOf("month"), dateFormatted: moment().locale(this.locale).subtract(1, "months").startOf("month").format("L")
    }
  };
  this.endDatePicker = {
    input: {
      date: moment().locale(this.locale).subtract(1, "days"), dateFormatted: moment().locale(this.locale).subtract(1, "days").format("L")
    }
  };

  // callbacks for lx-selects and lx-date-picker
  datePicker.autoClose($scope);
  this.specialtyCallback = specialtyCallback;

  function specialtyCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  function setDtHeaders(table) {
    $(table.column(getIndexOfColumn('dischargeDate')).header()).html($scope.vm.separationString + ' Date');
    $(table.column(getIndexOfColumn('speciality')).header()).html($scope.vm.specialtyString);
    $(table.column(getIndexOfColumn('wies')).header()).html("Original " + $scope.vm.episodeValue);
    $(table.column(getIndexOfColumn('finalWIES')).header()).html("Final " + $scope.vm.episodeValue);
    $(table.column(getIndexOfColumn('totalWIESChange')).header()).html($scope.vm.episodeValue + " Difference");
  }

  function getIndexOfColumn(columnName) {
    var selectedColumn = $scope.vm.dtColumns.filter(function (x) {
      return x.mData === columnName;
    });
    return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
  }

  function atsiCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  function filterAtsi(swap) {
    $scope.vm.atsi.selectedAtsi = [];
    if (swap === "add") {
      $scope.vm.atsi.selectedAtsi = $scope.vm.atsiOptions;
    }
  }

  function filterCampus(modifier) {
    $scope.vm.campus.selectedCampus = [];
    if (modifier === "add") {
      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
    }
  }

  function filterSpecialty(swap) {
    $scope.vm.specialty.selectedSpecialty = [];
    if (swap === "add") {
      $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
    }
  }

  function checkParam(param) {
    if (param.length !== 0) {
      return encodeURIComponent(param.join());
    } else {
      return "";
    }
  }

  this.changeData = changeData;

  function changeData() {
    var campus = "";
    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
        campus = $scope.vm.user.campus;
      } else {
        campus = $scope.vm.campus.selectedCampus;
      }
    } else {
      campus = $scope.vm.campus.selectedCampus;
    }

    var newUrl = $scope.vm.url + "startDate=" + $scope.vm.startDatePicker.input.dateFormatted + "&endDate=" + $scope.vm.endDatePicker.input.dateFormatted + "&specialty=" + checkParam($scope.vm.specialty.selectedSpecialty) + "&atsi=" + checkParam($scope.vm.atsi.selectedAtsi) + "&campus=" + checkParam(campus);
    if ($scope.vm.datatableApi) {
      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
    }
  }

  function search() {
    // delete any global searches previously applied
    if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();

    var auditTable = $scope.vm.datatableApi;
    var clearAuditTable = auditTable.search("").draw();

    filterCampus("minus");
    filterSpecialty("minus");
    filterAtsi([0, 1, 3]);

    // re-draw tabele on datepicker close
    $scope.$on("lx-date-picker__close-start", function (e, id) {
      $scope.vm.changeData();
    });
  }

  // bind the datatable instance to an object to monitor loading
  this.dtInstanceCallback = dtInstanceCallback;
  this.atsiCallback = atsiCallback;

  function dtInstanceCallback(dtInstance) {
    $scope.dtInstance = dtInstance._renderer;
  }

  // bind filter swap
  this.filterSwap = filterSwap;

  function filterSwap(thisFilter, thisModifier) {

    switch (thisFilter) {
      case "campus":
        if (thisModifier === "add") {
          filterCampus("add");
        } else {
          filterCampus("minus");
        }

        break;

      case "specialty":
        if (thisModifier === "add") {
          filterSpecialty("add");
        } else {
          filterSpecialty("minus");
        }

        break;

      case "atsi":
        filterAtsi(thisModifier);

        break;

      default:
        break;
    }
  }
};

exports.default = AtsiController;


// WEBPACK FOOTER //
// ./client/app/common/reports/atsi/atsi.controller.js